import type { SVGProps } from 'react'
interface SVGSearchProps extends SVGProps<SVGSVGElement> {
  pathClass?: string // Optional prop for path fill color
  color?: string
}
const SvgSearchIcon = ({ pathClass, ...props }: SVGSearchProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5315 12.6812L10.5634 9.71183C11.4533 8.55212 11.8688 7.09732 11.7256 5.64254C11.5823 4.18776 10.8911 2.84193 9.79204 1.87807C8.69301 0.914209 7.26849 0.404486 5.80746 0.452303C4.34642 0.500119 2.95828 1.10189 1.92462 2.13555C0.890956 3.16921 0.289181 4.55736 0.241365 6.01839C0.193549 7.47943 0.703272 8.90395 1.66713 10.003C2.631 11.102 3.97682 11.7933 5.4316 11.9365C6.88639 12.0798 8.34119 11.6643 9.50089 10.7743L12.4715 13.7456C12.5413 13.8153 12.6241 13.8707 12.7153 13.9084C12.8064 13.9462 12.9041 13.9656 13.0028 13.9656C13.1014 13.9656 13.1991 13.9462 13.2903 13.9084C13.3814 13.8707 13.4643 13.8153 13.534 13.7456C13.6038 13.6758 13.6591 13.593 13.6969 13.5018C13.7346 13.4107 13.7541 13.313 13.7541 13.2143C13.7541 13.1157 13.7346 13.018 13.6969 12.9268C13.6591 12.8357 13.6038 12.7528 13.534 12.6831L13.5315 12.6812ZM1.75089 6.21183C1.75089 5.37126 2.00015 4.54956 2.46715 3.85065C2.93414 3.15175 3.5979 2.60701 4.37449 2.28534C5.15107 1.96367 6.00561 1.8795 6.83003 2.04349C7.65444 2.20748 8.41172 2.61225 9.00609 3.20662C9.60047 3.801 10.0052 4.55828 10.1692 5.38269C10.3332 6.20711 10.2491 7.06165 9.92738 7.83823C9.60571 8.61482 9.06097 9.27858 8.36206 9.74557C7.66316 10.2126 6.84146 10.4618 6.00089 10.4618C4.87408 10.4607 3.79375 10.0125 2.99697 9.21575C2.20019 8.41897 1.75205 7.33864 1.75089 6.21183Z"
      fill="currentColor"
      className={pathClass}
    />
  </svg>
)
export default SvgSearchIcon
